import { fetcher } from "helpers/fetcher";

import {
  TGetJobListingRequirementsReq,
  TGetJobListingRequirementsRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getJobListingExperience = async (
  params?: TGetJobListingRequirementsReq
) => {
  return await fetcher<
    TGetJobListingRequirementsRes,
    TGetJobListingRequirementsReq["data"]
  >(ENDPOINT.CORPORATION.GET_JOB_LISTING_EXPERIENCE, {
    params: params?.data,
    headers: {
      [API_HEADER.VERSION]:
        ENDPOINT.CORPORATION.GET_JOB_LISTING_EXPERIENCE.version,
      [API_HEADER.CORP_ID]: params?.idCorp,
    },
  });
};

export const queryGetJobListingExperience = async (
  params?: TGetJobListingRequirementsReq
) => {
  return (await getJobListingExperience(params)).data;
};

queryGetJobListingExperience._key = (
  params?: TGetJobListingRequirementsReq,
  key?: number
) => [ENDPOINT.CORPORATION.GET_JOB_LISTING_EXPERIENCE.url, params, key];
